const DeviceManagementHover = () => {
    return (
<svg className='MuiSvgIcon-root' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <path id="Device-Management" d="M7,0A1,1,0,0,1,8,1V2h4V1a1,1,0,0,1,2,0V2h1a3,3,0,0,1,3,3V6h1a1,1,0,0,1,0,2H18v4h1a1,1,0,0,1,0,2H18v1a3,3,0,0,1-3,3H14v1a1,1,0,0,1-2,0V18H8v1a1,1,0,0,1-2,0V18H5a3,3,0,0,1-3-3V14H1a1,1,0,0,1,0-2H2V8H1A1,1,0,0,1,1,6H2V5A3,3,0,0,1,5,2H6V1A1,1,0,0,1,7,0ZM5,4A1,1,0,0,0,4,5V15a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1ZM6,7A1,1,0,0,1,7,6h6a1,1,0,0,1,1,1v6a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1Z"  fill-rule="evenodd"/>
</svg>

 
    )
}
export default DeviceManagementHover